"use client";

import { useTranslations } from "next-intl";
import { useMemo } from "react";

import { DELEGATED_VAULTS } from "@/constants/delegated-vaults";
import { useFundedTrialEligibilityQuery } from "@/contexts/queries/funded-trial/eligibility";

/** Static DELEGATED_VAULTS entries plus the FFT lock subaccount when the user has an active lock. */
export function useDelegatedSubaccounts(
  accountAddress: string | undefined,
): Array<{ subaccountAddress: string; label: string }> {
  const t = useTranslations("firstTradeOnUs");
  // Deliberately ungated: locked funds must stay visible after a rollout ramp-down.
  const { data: fftEligibility } = useFundedTrialEligibilityQuery({
    account: accountAddress,
  });
  const lockSubaccount = fftEligibility?.activeLockSubaccount;

  return useMemo(() => {
    const entries = DELEGATED_VAULTS[accountAddress?.toLowerCase() ?? ""] ?? [];
    if (!lockSubaccount) return entries;
    return [...entries, { subaccountAddress: lockSubaccount, label: t("lockedFundsLabel") }];
  }, [accountAddress, lockSubaccount, t]);
}
